<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/iot/terminal' }">终端管理</el-breadcrumb-item>
					<el-breadcrumb-item>RFID数据</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-tabs v-model="index">
					<el-tab-pane label="标签设备" name="first">
						<crud :fields="fields1" :select="select" :limits="limits" apiU="Epc" :timer="10"></crud>
					</el-tab-pane>
					<el-tab-pane label="天线列表" name="second">
						<crud :fields="fields2" :select="select" :limits="limits" apiU="Antenna" :timer="10"></crud>
					</el-tab-pane>
					<el-tab-pane label="实时数据" name="third">
						<crud :fields="fields3" :select="select" :limits="limits" apiU="Label" :timer="10"></crud>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				index: "first",
				fields1: [
					{
						name: 'devicesNo',
						label: '设备号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'epc',
						label: '标签号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'readNum',
						label: '读取总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'oneAntennaNo',
						label: '一号天线总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'twoAntennaNo',
						label: '二号天线总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'threeAntennaNo',
						label: '三号天线总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'fourAntennaNo',
						label: '四号天线总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'lastAntennaNo',
						label: '最后读取天线号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'lastTime',
						label: '最后读取时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				fields2: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'devicesNo',
						label: '设备号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'antennaNo',
						label: '天线号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'readNum',
						label: '读取总数',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'lastEpc',
						label: '最后读取标签号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'antennaStatus',
						label: '天线状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: "在线",
									value: 1
								},
								{
									label: "离线",
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'lastTime',
						label: '最后读取时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				fields3: [
					{
						name: 'devicesNo',
						label: '设备号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'antennaNo',
						label: '天线号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'epc',
						label: '标签号',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '读取时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [],
				limits: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
